"use client";

import { Icon } from "@/components/shared/icon";
import { Button } from "@/components/ui/button";
import {
  faArrowLeft,
  faBug,
  faHome,
  faSearch,
} from "@fortawesome/pro-solid-svg-icons";
import Link from "next/link";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export default function NotFound() {
  const posthog = usePostHog();

  useEffect(() => {
    // Track 404 errors
    posthog?.capture("page_not_found", {
      url: window.location.href,
      referrer: document.referrer,
      user_agent: navigator.userAgent,
    });
  }, [posthog]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 text-center">
      <div className="p-12 max-w-2xl">
        <Icon icon={faBug} size="6x" className="mb-8 text-blue-500" />

        <h1 className="text-6xl font-bold text-gray-800">404</h1>

        <h2 className="mt-4 text-2xl font-semibold text-gray-600">
          Oops! Page Not Found.
        </h2>

        <p className="mt-4 text-gray-500 leading-relaxed">
          It seems like you've found a glitch in the matrix. The page you're
          looking for doesn't exist or has been moved.
        </p>

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <div className="flex items-center justify-center gap-2 text-blue-700">
            <Icon icon={faSearch} size="sm" />
            <p className="text-sm font-medium">
              Try checking the URL for typos or use the navigation below
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            asChild
            variant="default"
            size="lg"
            className="flex items-center gap-2"
          >
            <Link href="/">
              <Icon icon={faHome} size="sm" />
              Go Home
            </Link>
          </Button>

          <Button
            onClick={() => window.history.back()}
            variant="outline"
            size="lg"
            className="flex items-center gap-2"
          >
            <Icon icon={faArrowLeft} size="sm" />
            Go Back
          </Button>
        </div>

        <div className="mt-8 text-sm text-gray-400">
          <p>Need help? Contact support in the help section of the sidebar.</p>
        </div>
      </div>
    </div>
  );
}
